import { Modal } from "react-bootstrap";
import Axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import Pagination from "react-js-pagination";
import Spinner from "./Spinner";

export default function ModalSearchMulti(props) {
    const {
        apiname,
        alldata,
        data,
        placeholder,
        name,
        onChange,
        colvalue,
        colname,
        defaultValue,
        all,
        autoSelect,
        onDataList,
        disabled,
        multiple = false,
    } = props;

    const { user } = useSelector((state) => state.auth);

    // 👉 chỉ dùng 1 state chứa tất cả item đã chọn
    const [selectedItems, setSelectedItems] = useState([]);
    const [keySearch, setKeySearch] = useState("");
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState(data ? data : []);
    const [page, setPage] = useState(1);
    const [totalpage, setTotalpage] = useState(0);
    const [param, setParam] = useState(alldata ? "?" + alldata : "?");
    const [totalRecord, setTotalRecord] = useState(10);
    const searchTimeout = useRef(null);

    // Load defaultValue
    useEffect(() => {
        if (multiple) {
            const arr = Array.isArray(defaultValue)
                ? defaultValue.map(v => {
                    if (typeof v === "object") return v;
                    const found = list.find(i => i.value === v);
                    return {
                        value: v,
                        label: found?.label || String(v),
                    };
                })
                : [];
            setSelectedItems(arr);
        } else {
            if (defaultValue) {
                const found = list.find(i => i.value === defaultValue);
                setSelectedItems([{
                    value: defaultValue,
                    label: found?.label || String(defaultValue)
                }]);
            } else {
                setSelectedItems([]);
            }
        }
    }, [defaultValue, multiple, list]);

    // Feed dữ liệu defaultValue ra input hiển thị
    useEffect(() => {
        if (!defaultValue) return;

        let config = {
            headers: {
                Authorization: "Bearer " + user.access_token,
                asselect: JSON.stringify([colvalue + " as value", colname + " as label"]),
            },
        };
        // multiple
        if (multiple && Array.isArray(defaultValue) && defaultValue.length > 0) {
            const onlyIds = defaultValue.every(v => typeof v === "number" || typeof v === "string");
            if (onlyIds) {
                Axios.get(
                    URL_LIST_ALL + apiname + "?list_value=" + encodeURIComponent(JSON.stringify(defaultValue)),
                    config
                )
                    .then((res) => {
                        if (res.data?.status === "success") {
                            const arr = res.data.data.map(i => ({
                                value: i.value,
                                label: i.label
                            }));
                            setSelectedItems(arr);
                        }
                    })
                    .catch(err => console.log(err));
            }
        }
    }, [defaultValue, multiple, apiname, user, colvalue, colname]);

    // Chỉ gọi API lấy tất cả danh sách khi mở modal
    useEffect(() => {
        let mounted = true;
        if (!data && show) {
            let config = {
                headers: {
                    Authorization: "Bearer " + user.access_token,
                    asselect: JSON.stringify([colvalue + " as value", colname + " as label"]),
                },
            };
            setLoading(true);

            Axios.get(URL_LIST_ALL + apiname + param + "&page=" + page, config)
                .then((res) => {
                    setLoading(false);
                    if (res.data && res.data.status === "success") {
                        if (mounted) {
                            let localList = [];
                            localList.push({ value: "", label: placeholder });
                            if (all === true) localList.push({ value: "all", label: "Tất cả" });
                            localList = localList.concat(res.data.data);

                            // 🔧 merge các item đang được chọn (nếu chưa có trong list)
                            const mergedList = [...localList];
                            selectedItems.forEach(sel => {
                                if (!mergedList.find(i => i.value === sel.value)) {
                                    mergedList.push(sel);
                                }
                            });

                            setList(mergedList);
                            setTotalRecord(res.data.total);
                            setTotalpage(res.data.totalpage);

                            if (onDataList) onDataList(mergedList);
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        }
        return () => (mounted = false);
    }, [user, apiname, data, colvalue, colname, all, alldata, param, page, show]);


    // Toggle chọn item
    const toggleSelect = (item) => {
        if (!multiple) {
            setSelectedItems([{ value: item.value, label: item.label }]);
            onChange(item.value);
            setShow(false);
        } else {
            if (selectedItems.find((i) => i.value === item.value)) {
                setSelectedItems(selectedItems.filter((i) => i.value !== item.value));
            } else {
                setSelectedItems([...selectedItems, { value: item.value, label: item.label }]);
            }
        }
    };

    // Xoá item trong danh sách đã chọn
    const removeItem = (value) => {
        setSelectedItems(selectedItems.filter((i) => i.value !== value));
    };

    // Confirm khi multiple
    const confirmSelect = () => {
        onChange(selectedItems.map((i) => i.value));
        setShow(false);
    };

    // debounce search
    const searchOnchange = (value) => {
        clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            setParam("?&key=" + value);
            setPage(1);
        }, 500);
    };

    return (
        <div className="search-box-modal height32">
            <div className="input-group mb-3">
                <input
                    type="text"
                    className="form-control height32"
                    value={
                        multiple
                            ? selectedItems.map(i => i.label).join(", ")
                            : (selectedItems[0]?.label || "")
                    }
                    readOnly
                    placeholder={placeholder}
                />
                <input
                    type="hidden"
                    name={name}
                    value={
                        multiple
                            ? JSON.stringify(selectedItems.map(i => i.value))
                            : (selectedItems[0]?.value || "")
                    }
                />
                {!disabled && (
                    <div className="input-group-prepend">
                        <button
                            type="button"
                            className="btn btn-sm btn-success height32"
                            onClick={() => {
                                setShow(true);
                            }}
                        >
                            Chọn
                        </button>
                    </div>
                )}
            </div>

            <Modal show={show} onHide={() => setShow(false)} animation={true} size="md">
                <Modal.Header closeButton>
                    <Modal.Title>{placeholder}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {show && (
                        <div className="w-100 list-search-box">
                            {list ? (
                                <>
                                    <div className="input-group mb-3">
                                        <input
                                            type="text"
                                            className="form-control height32"
                                            placeholder="Tìm kiếm"
                                            onChange={(e) => setKeySearch(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();

                                                    if (keySearch && keySearch.trim() !== '') {
                                                        searchOnchange(keySearch.trim());
                                                    }
                                                }
                                            }}
                                        />
                                        <div className="input-group-prepend">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-success height32"
                                                onClick={() => {
                                                    if (keySearch && keySearch !== "")
                                                        searchOnchange(keySearch.trim());
                                                }}

                                            >
                                                <span className="fas fa-search"></span>
                                            </button>
                                        </div>
                                    </div>

                                    {/* Load list đã chọn */}
                                    <div className="mb-2">

                                        {selectedItems.map((item) => (
                                            <span
                                                key={item.value}
                                                className="btn btn-sm btn-outline-success mr-2 mb-2"
                                            >
                                                {item.label}
                                                <button
                                                    type="button"
                                                    className="btn btn-sm p-0 bg-transparent text-danger ml-1"
                                                    onClick={() => removeItem(item.value)}
                                                >
                                                    <span className="fas fa-times"></span>
                                                </button>
                                            </span>
                                        ))}
                                    </div>

                                    {loading && (
                                        <div className="w-100 d-flex justify-content-center pt-3 pb-3">
                                            <Spinner />
                                        </div>
                                    )}

                                    <ul className="w-100 list-data">
                                        {list.map((item) => {
                                            const isSelected = selectedItems.find(
                                                (i) => i.value === item.value
                                            );
                                            return (
                                                <li
                                                    key={item.value}
                                                    onClick={() => toggleSelect(item)}
                                                    className={isSelected ? "active" : ""}
                                                    style={{
                                                        cursor: "pointer",
                                                        fontWeight: isSelected ? "bold" : "normal",
                                                    }}
                                                >
                                                    {multiple && (
                                                        <input
                                                            type="checkbox"
                                                            checked={!!isSelected}
                                                            readOnly
                                                            className="mr-2"
                                                        />
                                                    )}
                                                    {item.label}
                                                </li>
                                            );
                                        })}
                                    </ul>

                                    {totalpage > 1 && (
                                        <div className="w-100 d-flex justify-content-center mt-2 pagination-group">
                                            <Pagination
                                                activePage={page}
                                                itemsCountPerPage={10}
                                                totalItemsCount={totalRecord}
                                                pageRangeDisplayed={5}
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                prevPageText="<"
                                                nextPageText=">"
                                                onChange={setPage}
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <h3>Không có dữ liệu</h3>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => setShow(false)}
                    >
                        Đóng
                    </button>
                    {multiple && (
                        <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={confirmSelect}
                        >
                            Chọn
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
}
